import { lazy } from "react";
import Loadable from "../../../../../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../../../../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../../../../../constants/enums";

const HabitationalCSIOMpoiWrapper = Loadable(
  lazy(() =>
    import("./HabitationalCSIOMpoiWrapper").then(({ HabitationalCSIOMpoiWrapper }) => ({
      default: HabitationalCSIOMpoiWrapper,
    }))
  )
);
const HabitationalMpoiWrapper = Loadable(
  lazy(() =>
    import("./HabitationalMpoiWrapper").then(({ HabitationalMpoiWrapper }) => ({
      default: HabitationalMpoiWrapper,
    }))
  )
);

export const  HabitationalCSIOMpoiWrapperRouter = [
  {
    path: `/habitational-policy/:customerId/csio-mpoi/:customerPolicyId/`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <HabitationalCSIOMpoiWrapper />
      </AuthorizedRoute>
    ),
  },
  {
    path: `/habitational-policy/:customerId/csio-mpoi/:customerPolicyId/manage`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <HabitationalMpoiWrapper />
      </AuthorizedRoute>
    ),
  },
  {
    path: `/habitational-policy/:customerId/csio-mpoi/:customerPolicyId/manage/:premiumNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <HabitationalMpoiWrapper />
      </AuthorizedRoute>
    ),
  },
];
